import { useTLang } from 'intl/intl';
import { orderTypeAsFlags } from './OrderTypeChip.util';

import type { OrderType } from './OrderTypeChip.type';

export function useOrderTypeChipTexts(props: Props) {
  const { orderType } = props;
  const { isBundle } = orderTypeAsFlags(orderType);

  // TODO: lang for priority is not ready yet in ES or PT-BR
  const bundleId = 'orderType.chip.bundle';
  const priorityId = 'orderType.chip.priority';

  return useTLang({ id: isBundle ? bundleId : priorityId });
}

interface Props {
  orderType: OrderType;
}
